var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32611 7.42461L9.78626 13.7965C9.87428 13.8991 9.98345 13.9815 10.1063 14.038C10.2291 14.0945 10.3628 14.1238 10.498 14.1238C10.6332 14.1238 10.7668 14.0945 10.8897 14.038C11.0125 13.9815 11.1217 13.8991 11.2097 13.7965L16.6699 7.42461C17.191 6.81641 16.7589 5.87695 15.9581 5.87695H5.03626C4.23548 5.87695 3.80345 6.81641 4.32611 7.42461Z",
    fill: "#8493B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownIcon);
export default __webpack_public_path__ + "static/media/caret-down_icon.e3c8ef22c9dd5bc8fe7e2240dfab058b.svg";
export { ForwardRef as ReactComponent };